<script lang="ts">
	import { format } from 'svelte-i18n';
	//Components
	import VirtualButton from './VirtualButton.svelte';
	import VirtualBooleanButton from './VirtualBooleanButton.svelte';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Design system components
	import {
		Text,
		type DeviceButtonV2PropsTypes,
		type LabelPropsTypes,
	} from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let statuses: any;
	export let isWide = false;
	export let useV2Components = false;
	export let deviceButtonV2Props: Partial<DeviceButtonV2PropsTypes> = {
		size: 'm',
	};
	export let labelProps: Partial<LabelPropsTypes> = {};

	$: status = statuses.find((i) => i?.hasButton || i?.isBleButton);
	$: statusLabel = capFirstChar(
		status?.event
			? $format('label_action_turn_off', { default: 'turn off' })
			: $format('label_action_turn_on', { default: 'turn on' }),
	);
</script>

{#if status?.vcType == 'button'}
	<VirtualButton
		{device}
		componentID={status.id}
		value={status.event}
		icon={status.icon}
		disabled={status.isBleButton}
		{isWide}
		{useV2Components}
		{labelProps}
		{deviceButtonV2Props}
	/>
{:else if status?.vcType == 'boolean'}
	<VirtualBooleanButton
		{device}
		componentID={status.id}
		value={status.event}
		{isWide}
		{useV2Components}
		{deviceButtonV2Props}
	/>
	{#if isWide}
		<Text styleType="controls-large" class="mt-s text-bold"
			>{status.wideBtnLabel ? status.wideBtnLabel : statusLabel}</Text
		>
	{/if}
{/if}
